import { render, staticRenderFns } from "./FormNav.vue?vue&type=template&id=24473e5f"
import script from "./FormNav.vue?vue&type=script&lang=js"
export * from "./FormNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports